import React from 'react'

const ShopContext = React.createContext('shop')

export default ShopContext
